/**
 * 바이트 단위를 사람이 읽기 쉬운 형식으로 변환
 * @param {number} bytes - 바이트 단위 크기
 * @returns {string} 포맷팅된 크기 (예: 1.5 MB)
 */
export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

/**
 * CPU 시간을 사람이 읽기 쉬운 형식으로 변환
 * @param {number} nanoseconds - 나노초 단위 CPU 시간
 * @returns {string} 포맷팅된 CPU 시간 (예: 1h 30m 45s)
 */
export const formatCpuTime = (nanoseconds) => {
  if (nanoseconds === 0) return '0초';

  // 나노초를 초로 변환
  const totalSeconds = Math.floor(nanoseconds / 1000000000);
  
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts = [];
  if (hours > 0) parts.push(`${hours}시간`);
  if (minutes > 0) parts.push(`${minutes}분`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}초`);

  return parts.join(' ');
};

/**
 * 메모리 크기를 KB에서 사람이 읽기 쉬운 형식으로 변환
 * @param {number} kilobytes - KB 단위 메모리 크기
 * @returns {string} 포맷팅된 메모리 크기 (예: 4 GB)
 */
export const formatMemory = (kilobytes) => {
  if (kilobytes === 0) return '0 MB';

  const mb = kilobytes / 1024;
  const gb = mb / 1024;

  if (gb >= 1) {
    return `${parseFloat(gb.toFixed(1))} GB`;
  } else {
    return `${Math.round(mb)} MB`;
  }
};

/**
 * 타임스탬프를 사람이 읽기 쉬운 날짜 형식으로 변환
 * @param {number} timestamp - Unix 타임스탬프
 * @returns {string} 포맷팅된 날짜 (예: 2023-06-15 15:30:45)
 */
export const formatDate = (timestamp) => {
  const date = new Date(timestamp * 1000);
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}; 